import React, { Component } from 'react';
import Checkbox from '../../../shared/components/checkbox';
import { FormattedMessage } from 'react-intl';
import { PropTypes } from 'prop-types';
import RadioButtonList from '../../../shared/components/radio-button/radio-button-list';
// import RadioButton from '../../../shared/components/radio-button/radio-button';


class ClaimSearchAside extends Component {


    radioChangeHandler = event => {

        const updatedParameters = { ...this.props.viewOptions };
        console.log(event.target.value);
    
        updatedParameters.includeExpandedClaimDetail = false;
        updatedParameters.includeShortView = false;
        updatedParameters.includeAGCMDView = false;

        if (event.target.value === "Expanded View") {
            updatedParameters.includeExpandedClaimDetail = true;
          } else if (event.target.value === "Short View") {
            updatedParameters.includeShortView = true;
          } else if (event.target.value === "Credit Memo Download") {
            updatedParameters.includeAGCMDView = true;
          }
        const selectedOption = {
            target: {
                name: 'option',
                value: updatedParameters,
            },
        };
        this.props.onUpdateProperty( selectedOption );

    }

    toggleCheckbox = item => {

        const updatedParameters = { ...this.props.viewOptions };
        updatedParameters[item] = !this.props.viewOptions[item];
        console.log("updatedParameters",updatedParameters);

        const selectedOption = {
            target: {
                name: 'option',
                value: updatedParameters,
            },
        };
        this.props.onUpdateProperty( selectedOption );

    }

    getNameById = id => {

        const nameIdPair = {

                includeComplaintCauseCorrection: "Show 3 C's",
                includeComplaintCauseCorrectionTranslation: "3 C's with Translations",
                includeRejects: 'Include Rejects',
                include17CharacterPin: 'Include 17 Digit Pin',
                includeAttachmentCount: 'Attachment Count',
                showAGCMDLView: 'AGCMDL View',

            },

            name = Object.keys( nameIdPair ).filter( key => key === id );
        return nameIdPair[name];

    }

    render () {

        const viewParameters = [
            {
                label: 'Short View',
                isSelected: !this.props.viewOptions.includeExpandedClaimDetail && !this.props.viewOptions.includeAGCMDView,
            },
            {
                label: 'Expanded View',
                isSelected: this.props.viewOptions.includeExpandedClaimDetail,
            },
            {
                label: "Credit Memo Download",
                isSelected: this.props.viewOptions.includeAGCMDView
              }
            
        ];

      //  console.log("item ",this.props.viewOptions);

        return (
            <section>
                <div>
                    <RadioButtonList
                        changed={this.radioChangeHandler}
                        items={viewParameters}
                        label="View Detail"
                    />
                    <div className="checkbox-fixed-container">
                        <h4>
                            <FormattedMessage id="View Options" />
                        </h4>

                        <ul>

                            {Object.keys( this.props.viewOptions )
                             .filter((item) => item !== "includeExpandedClaimDetail" && item !== "includeShortView" && item !== "includeAGCMDView")
                            .map( ( item, index ) => (
                                
                                    <Checkbox
                                        className={( item === 'includeAttachmentCount' && this.props.viewOptions.includeExpandedClaimDetail !== true ? 'disable-Cls' : '' ) || 
                                        ( item === 'includeComplaintCauseCorrectionTranslation' && this.props.viewOptions.includeComplaintCauseCorrection !== true ? 'disable-Cls' : '' ) 
                                    || ((item === 'includeComplaintCauseCorrection' || item === 'includeRejects' || item === 'include17CharacterPin' ) && this.props.viewOptions.includeAGCMDView === true && this.props.viewOptions.includeComplaintCauseCorrection !== true ? 'disable-Cls' : '')}
                                        label={this.getNameById( item )}
                                        value={item}
                                        handleCheckboxChange={this.toggleCheckbox}
                                        key={item}
                                        isChecked={( item === 'includeAttachmentCount' && this.props.viewOptions.includeExpandedClaimDetail !== true ? false : this.props.viewOptions[item] ) && ( item === 'includeComplaintCauseCorrectionTranslation' && this.props.viewOptions.includeComplaintCauseCorrection !== true ? false : this.props.viewOptions[item] )}
                                        id={index}
                                    />
                                
                            ) )}

                        </ul>
                    </div>

                </div>
            </section>
        );

    }

}
ClaimSearchAside.displayName = 'ClaimSearchAside';
ClaimSearchAside.propTypes = {
    viewOptions: PropTypes.object.isRequired,
    onUpdateProperty: PropTypes.func.isRequired,
};
export default ClaimSearchAside;
